/**
 * Decodes base64 (the compiler's `pdfBase64`) to bytes. A plain loop: the
 * `Uint8Array.from(atob(x), (c) => c.charCodeAt(0))` form calls a function per
 * byte through the string iterator and measured 7-13x slower (a 9-page document:
 * 406 ms against 31 ms at 4x CPU throttling), on the path to every preview.
 */
export function base64ToBytes(base64: string): Uint8Array {
  const binary = window.atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let index = 0; index < binary.length; index += 1) bytes[index] = binary.charCodeAt(index);
  return bytes;
}
